import React from "react";
import styles from "./skeleton.css";
import { NUMBER } from "../../../constants/app-constants";

const Skeleton = () => {
    return (
        <div styleName="styles.skeletonWrapper">
            {[NUMBER.ONE, NUMBER.TWO, NUMBER.THREE].map((item) => (
                <div key={item} styleName="styles.skeletonCard">
                    <div styleName="styles.skeletonHeader">
                        <div className="shimmer" styleName="styles.skeletonIcon" />
                        <div className="shimmer" styleName="styles.skeletonTitle" />
                    </div>
                    <div className="shimmer" styleName="styles.skeletonDescription" />
                    <div className="shimmer" styleName="styles.skeletonDescriptionShort" />
                </div>
            ))}
        </div>
    );
};

export default Skeleton;
